/* eslint-disable max-params */
import * as ProjectActionType from 'Projects/constants';

class InventoryServices {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  getInventoryById = (id, callback) => {
    this.dispatch({
      type: ProjectActionType.GET_CATEGORY_PROFILE_DETAILS_ASYNC,
      params: { id },
      callback
    });
  }

  getInventoryList = (projectId, callback) => {
    this.dispatch({
      type: ProjectActionType.GET_LIST_CATEGORY_ASYNC,
      params: { projectId },
      callback
    });
  }

  removeInventory = (id, callback) => {
    this.dispatch({
      type: ProjectActionType.DELETE_CATEGORY_ITEM_ASYNC,
      params: { id },
      callback
    });
  }

}

export default InventoryServices;



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/services.js